import styled from 'styled-components';
import { Heading } from '@kl/components-v6';
import { StyledFlexContainer } from 'shared/ui/styled-components';
import { LocalizedText } from 'shared/ui/localized-text';

type StyledBlockContainerProps = {
    $direction?: 'column' | 'row' | 'row-reverse';
};

export const StyledBlockContainer = styled.div<StyledBlockContainerProps>`
    display: flex;
    flex-direction: ${({ $direction }) => $direction};
    gap: 24px;
    width: 100%;
    align-items: center;
`;

export const StyledBlockWrapper = styled(StyledFlexContainer)`
    flex: 1;
`;

export const StyledImgWrapper = styled.img`
    flex: 1;
    min-width: 0;
    width: 100%;
    filter: drop-shadow(0px 0px 1px rgba(0, 0, 0, 0.6))
        drop-shadow(-4px 0px 10px rgba(0, 0, 0, 0.15));
    border-radius: 8px;
    image-rendering: -webkit-optimize-contrast;
`;

export const StyledProductLogoFigure = styled.figure`
    width: 64px;
    margin: 0;
`;

export const StyledProductLogoImage = styled.img`
    width: 100%;
    height: auto;
`;

export const StyledOptionText = styled(LocalizedText)`
    flex: 1;
`;
